import $API from '../services/bixe-api.service';
import { alerts as alertMessages } from '../shared/messages/alerts';
import { bixeAppDownloadUrl, bixeStagingAppDownloadUrl, bixeNativeAppProtocols } from '../shared/constants';

const utilityLib = {
  desanitizeString(str) {
    if (!str) {
      return '';
    }

    const sanitizedKeysMap = {
      "'": "'",
      '"': '"',
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '%60': '`',
    };
    /* eslint-disable */
    Object.entries(sanitizedKeysMap).forEach(([key, value]) => {
      const regex = new RegExp(key, 'ig');
      str = str.replace(regex, value);
    });

    return str;
  },

  sanitizeString(str) {
    if (!str) {
      return '';
    }

    const sanitizedKeysMap = {
      "'": "'",
      '"': '"',
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '`': '%60',
    };
    /* eslint-disable */
    Object.entries(sanitizedKeysMap).forEach(([key, value]) => {
      const regex = new RegExp(key, 'ig');
      str = str.replace(regex, value);
    });

    return str;
  },

  cleanDeviceLabel(p) {
    let regex = /\(.*[a-zA-Z0-9]+:.*[a-zA-Z0-9]+\)/i;
    return p.replace(regex, '');
  },

  isOpenedWithinElectronShell() {
    return typeof ipcApi !== 'undefined' && ipcApi.send;
  },

  getNativeAppProtocol: (env) => {
    return env === 'production' ? bixeNativeAppProtocols.prod : bixeNativeAppProtocols.stagingAndDev;
  },

  storage: {
    ss: {
      setItem: (key, value) => {
        window.sessionStorage.setItem(key, value);
      },
      getItem: (key) => {
        return window.sessionStorage.getItem(key);
      },
      removeItem: (key) => {
        window.sessionStorage.removeItem(key);
      },
    },
    ls: {
      setItem: (key, value) => {
        window.localStorage.setItem(key, value);
      },
      getItem: (key) => {
        return window.localStorage.getItem(key);
      },
      removeItem: (key) => {
        window.localStorage.removeItem(key);
      },

    }
  },

  genericFns: {
    saveMeetingJoinedViaDetails: (meetingId, joinedVia) => {
      let joinedViaDetails = JSON.parse(sessionStorage.getItem('meetingsJoinedViaDetails') || '[]');
      const meetingDetailsExists = joinedViaDetails.some((item) => item.meetingId === meetingId);
      if (!meetingDetailsExists) {
        joinedViaDetails.push({ meetingId, joinedVia });
        if (joinedViaDetails.length > 5) {
          joinedViaDetails.shift(); // remove oldest entry to limit size
        }
        sessionStorage.setItem('meetingsJoinedViaDetails', JSON.stringify(joinedViaDetails));
      }
    },
    getMeetingJoinedViaDetails: (meetingId) => {
      const joinedViaDetails = JSON.parse(sessionStorage.getItem('meetingsJoinedViaDetails') || '[]');
      const meetingDetails = joinedViaDetails.find((item) => item.meetingId === meetingId);
      return meetingDetails ? meetingDetails.joinedVia : null;
    },
    removeQueryParams: (paramName) => {
      const url = new URL(window.location.href);
      url.searchParams.delete(paramName)
      window.history.pushState(null, '', url.toString());
    },
    startNewMeetingParams() {
      const now = Math.floor(Date.now() / 1000);
      return {
        starts_on: now,
        ends_on: now + 60 * 60,
        created_on: now,
        template: 'quickstart',
        consumer: 'conference',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    },
    quickStartMeeting: ({ preferredMeetingType = '' } = {}) => {
      return new Promise((resolve, reject) => {
        const data = utilityLib.genericFns.startNewMeetingParams();
        $API.createMeeting({ preferredMeetingType, ...data })
          .then((meeting) => {
            resolve(meeting)
          })
          .catch((err) => {
            reject(err)
          });
      });
    },
    joinPersonalRoomMeeting: ({ pinNumber, password, preferredMeetingType = '' }) => {
      const { created_on, ...data } = {
        password, preferredMeetingType, ...utilityLib.genericFns.startNewMeetingParams()
      };
      return new Promise((resolve, reject) => {
        $API.joinRoomMeeting(pinNumber, data)
          .then((meeting) => {
            resolve(meeting)
          })
          .catch((err) => {
            reject(err)
          });
      });
    },
    showNativeNotification: ({ type, userId, userName, hasActions = true, specialChar = '' }) => {
      return new Promise((resolve) => {
        const notificationObj = {
          type,
          userId,
          userName,
          hasActions,
          name: 'showNativeNotification',
          message: alertMessages[type]?.content({ userName, userId, specialChar }),
          onlyShowIfMinimized: true,
        };
        ipcApi
          .send(notificationObj)
          .then((resp) => {
            const parsed = resp ? JSON.parse(resp) : { action: '' };
            if (!parsed.action) {
              // TODO: send a socket event to main window to show this notification
              // alert("Unsupported!!!")
              resolve({ doIt: false, message: 'unsupported' });
            } else if (parsed.action === 'mainWindowIsNotMinimized') {
              resolve({ doIt: false, message: 'mainWindowIsNotMinimized' });
            } else if (parsed.action) {
              resolve({ doIt: parsed.action === 'yes' });
            }
          })
          .catch(() => {
            resolve({ doIt: false });
          });
      })
    },
    getDownloadAppLink: () => {
      const isMacOs = !!window.navigator.platform?.match(/mac/gi);
      const isUsingProd = window.__INITIAL_STATE__?.config?.environment === 'production';
      let downloadUrl = null;
      if (isUsingProd) {
        downloadUrl = isMacOs ? bixeAppDownloadUrl.macOS : bixeAppDownloadUrl.windows;
      } else {
        downloadUrl = isMacOs ? bixeStagingAppDownloadUrl.macOS : bixeStagingAppDownloadUrl.windows;
      }
      return `${downloadUrl}?requested-at=${Date.now()}`;
    },
    isNewerVersionAvailable: (currentVersion, availableVersion) => {
      if (!currentVersion || !availableVersion) {
        return false;
      }
      const currentVer = currentVersion.split('.').map((v) => parseInt(v, 10));
      const availableVer = availableVersion.split('.').map((v) => parseInt(v, 10));

      for (let i = 0; i < Math.max(currentVer.length, availableVer.length); i++) {
        const current = currentVer[i] || 0;
        const available = availableVer[i] || 0;
        if (current < available) {
          return true;
        } else if (current > available) {
          return false;
        }
      }
      return false;
    }
  },

  clipBoard: {
    addItem(item) {
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(item)
      }
    }
  }
};

export default utilityLib;